/* unplugin-vue-components disabled */import { render } from "./xButtonGroup.vue?vue&type=template&id=470c1169"
import script from "./xButtonGroup.vue?vue&type=script&lang=js"
export * from "./xButtonGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__